import { getAppUserPolicy } from '@/api/api.js';

export const state = {
  wsAppUserPolicy: [],
  alertPeriod: false,
  alertNoFeature: false,
  alertNoWMTSFeature: false,
  updateStep: false,
  pauseAnimation: false,
  rangeDateTime: [],
  activeServices: [],
  autoOpenRangeDate: false
};

export const mutations = {
  PUSH_WS_SERVICE(state, data) {
    state.wsAppUserPolicy = [];
    state.wsAppUserPolicy = data;
  },
  CLEAR_ACTIVE_SERVICES(state) {
    state.activeServices = [];
    state.alertNoWMTSFeature = false;
    state.alertPeriod = false;
  },
  ADD_ACTIVE_SERVICE(state, service) {
    const existing = state.activeServices.find(
      s => s.service_id === service.service_id
        && s.layer_name === service.layer_name
    );

    if (existing) {
      Object.assign(existing, service);
    } else {
      state.activeServices.push(service);
    }
  },
  REMOVE_ACTIVE_SERVICE(state, service_id) {
    state.activeServices = state.activeServices.filter(s => s.service_id !== service_id);
  },
  CLEAR_RANGE_DATE_CONTROLLER(state) {
    state.rangeDateController = [];
  },
  CLEAR_TIME_DATE_CONTROLLER(state) {
    state.rangeTimeController = [];
  },
  SET_AUTO_OPEN_RANGE_DATE(state, value) {
    state.autoOpenRangeDate = value;
  }
};

export const actions = {
  async storeWsServices({ commit, dispatch }, data) {
    try {
      const wsService = await getAppUserPolicy(data);
      commit('PUSH_WS_SERVICE', wsService.data.listAppUserPolicy[0].WS);
    } catch (err) {
      dispatch(
        'storeToastMessage',
        {
          text: 'storeWsServices',
          errObj: err,
          type: 'danger'
        },
        { root: true }
      );
    }
  },
  async removeAllActiveServices({ commit, dispatch }) {
    try {
      commit('CLEAR_ACTIVE_SERVICES');
    } catch (err) {
      dispatch(
        'storeToastMessage',
        {
          text: 'removeAllActiveServices',
          errObj: err,
          type: 'danger'
        },
        { root: true }
      );
    }
  },
  async addActiveService({ commit, dispatch }, service) {
    try {
      commit('ADD_ACTIVE_SERVICE', service);
    } catch (err) {
      dispatch(
        'storeToastMessage',
        {
          text: 'addActiveService',
          errObj: err,
          type: 'danger'
        },
        { root: true }
      );
    }
  },
  async removeActiveService({ commit, dispatch }, service_id) {
    try {
      commit('REMOVE_ACTIVE_SERVICE', service_id);
    } catch (err) {
      dispatch(
        'storeToastMessage',
        {
          text: 'removeActiveService',
          errObj: err,
          type: 'danger'
        },
        { root: true }
      );
    }
  },
  async clearRangeDateController({ commit, dispatch }) {
    try {
      commit('CLEAR_RANGE_DATE_CONTROLLER');
    } catch (err) {
      dispatch(
        'storeToastMessage',
        {
          text: 'clearRangeDateController',
          errObj: err,
          type: 'danger'
        },
        { root: true }
      );
    }
  },
  async clearRangeTimeController({ commit, dispatch }) {
    try {
      commit('CLEAR_RANGE_TIME_CONTROLLER');
    } catch (err) {
      dispatch(
        'storeToastMessage',
        {
          text: 'clearRangeTimeController',
          errObj: err,
          type: 'danger'
        },
        { root: true }
      );
    }
  },
  async setAutoOpenRangeDate({ commit, dispatch }, value) {
    try {
      await commit('SET_AUTO_OPEN_RANGE_DATE', value);
    } catch (err) {
      dispatch(
        'storeToastMessage',
        {
          text: 'setAutoOpenRangeDate',
          errObj: err,
          type: 'warning'
        },
        { root: true }
      );
    }
  }
};

export const getters = {};
